import { Component, OnInit } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { MapComponent } from '../map/map.component';
import { ConfirmDeleteDialogComponent } from '../confirm-delete-dialog/confirm-delete-dialog.component';
import { VenueService } from '../../services/venue.service';
import { Venue  } from '../../models/venue';
import { MessageBoxDialog } from '../message-box/message-box.component';

@Component({
  selector: 'app-venue',
  templateUrl: './view-venue.component.html',
  styleUrls: ['./view-venue.component.css']
})
export class ViewVenueComponent implements OnInit {
  selectedOption: string;
  publicating: boolean = false;
  venues: any;
  errorMessage:string;
  loading_venue: boolean;

  page: number;
  total: number;
  max: number;

  constructor(public dialog: MdDialog, public venueService: VenueService) { 
      this.loading_venue = true;
      this.page = 1;
      this.total = 0;
      this.max = 5;
  }

  ngOnInit() {
    
    this.searchVenues();
    /*this.venueService.getVenues()
      .subscribe(
        data => {
            this.venues = data;
            this.loading_venue = false;
          },
        error => this.errorMessage = <any>error
      );*/
  }

  _keyPressNumber(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  _keyPressLetter(event: any) {
    const pattern = /^[a-zA-Z]+$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  onPageChangeV(page) {
    this.searchVenues(page);
  }

  searchVenues (page?: number, query?: string) {
    this.loading_venue = true;
    const status = [];
    this.page = page;
    if (page == null) {
      page = 1;
    }

    this.venueService.getVenuesByPage(page, this.max, query)
    .subscribe(
    data => {
      this.venues = data.venues;
      this.total = data.pagination.total;
      this.loading_venue = false;
    },
    error => {
      if (error.status == 404) {
        this.venues = undefined;
        this.loading_venue = false;
      } else {
        console.log(error);
        this.venues = undefined;
        this.loading_venue = false;
      }
    });
  }

  onPutVenue() {
    this.publicating = true;
    this.venueService.putVenues(this.venues)
      .subscribe(
        data => {
          this.publicating = false;
        },
        error => {
          this.errorMessage = <any>error
          this.publicating = false;
        }
      );
  }

  openDialog(sendData, venue) {
      let dialogRef = this.dialog.open(MapComponent);

      if (sendData) {
        dialogRef.componentInstance.venue_id = venue.id;
        dialogRef.componentInstance.venue_name = venue.name;
        dialogRef.componentInstance.venue_lat = venue.lat;
        dialogRef.componentInstance.venue_lng = venue.lng;
        dialogRef.componentInstance.venue_address = venue.address;
        dialogRef.componentInstance.sendData = sendData;
      }

      dialogRef.afterClosed().subscribe(result => {
        this.selectedOption = result;
        this.searchVenues(this.page);
      });
      
  }

  openDialogDelete(id) {
      let dialogRef = this.dialog.open(ConfirmDeleteDialogComponent);
      dialogRef.componentInstance.VenueID=id;
      dialogRef.componentInstance.deleteVenue=true;
      dialogRef.afterClosed().subscribe(result => {
        this.selectedOption = result;
        this.searchVenues(this.page);
      });
  }

  showInformation() {
    this.dialog.open(MessageBoxDialog, {data: {message: 'Crea sedes para gestionar la geolocalización laborales y asignar a las ofertas.', information: true, showIcon: true}});
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/view-venue/view-venue.component.ts